(() => {
  function init() {
    document.querySelectorAll('[data-funtek-series]').forEach(module => {
      if(module.dataset.seriesBound) return;
      module.dataset.seriesBound = 'true';
      const section = module.closest('.funtek-product-main');
      if(!section) return;
      const place = () => { const spec = section.querySelector('.product__specifications'); if(spec && spec.nextElementSibling !== module) spec.after(module); };
      place();
      const query = matchMedia('(min-width: 990px)');
      query.addEventListener('change', () => requestAnimationFrame(place));
      window.addEventListener('load', place, {once:true});
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
